import React, { Component } from "react";
import Landing from "./LandingContainer";
import MassiveComponent from '../components/MassiveComponent'
import MassivePrompt from '../components/MassiveLoadPropmt'
import LoaderDots from '../../Modal/components/LoaderDots'
import SocketClient from 'socket.io-client'
import { api_base } from './../../constants/services/api'

import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard"

import { sendFile } from '../../Services/service'

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sessionActs from './../../Actions/Session';

import '../massiveStyle.css'

class MassiveLoadContainer extends Component {
  state = {
    form: {},
    hasFooter: false,
    propmt: [],
    load: false,
    first: true
  };
  handlerChange = (variable, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [variable]: value
      }
    });
  };

  handlerSubmit = () => {
    this.setState({ load: true, propmt: ['--------------------------------------------------------------------------------------------------------------'] })
    let data = new FormData()
    data.append('xlsFile', this.state.form.xlsFile)
    data.append('cutDate', this.state.form.cutDate)
    data.append('type', parseInt(this.state.form.type))
    data.append('source', parseInt(this.state.form.source))
    const functions = { start: this.onStart, end: this.onEnd, onprogress: this.onProgress, error: this.onError }
    sendFile('/api/v1/dashboard/upload', data, functions)
  }

  onStart = (e) => {
    console.log('start', e)
  }

  onEnd = (e) => {
    console.log('TEEERRRMIIINAAA')    
    this.setState({first:false})
  }

  onProgress = (e) => {
    if (e.lengthComputable) {
      console.log(e.loaded + " / " + e.total)
    }
  }

  onError = (e) => {
    console.log('error', e)
  }

  componentDidMount = () => {
    this.socket = SocketClient(api_base + '/api/v1/dash/uploadMassive')
    this.socket.on('socketPath', data => this.recieveData(data))
    console.log(this.props)
    this.socket.emit('evento', 'ok')
  }

  recieveData = (resp) => {
    let data = JSON.parse(resp)
    this.setState({ 
      propmt: data.data.texts, 
      load: (data.data.state === "active") ? true : false,  
    })
  }

  componentWillUnmount() {
    this.socket.disconnect()
  }

  render() {
    return (
      <Landing history={this.props.history} hasFooter={this.state.hasFooter}>
        <div>
          <h1 className="page-title">{LANDING_MENU_BAR.MASSIVE_LOAD}</h1>
        </div>
        <div className="background-body">
          <div className="container-content">
            <div className={this.state.hasFooter ? "content-line" : "content-line content-line-no-footer"} >
              {
                !this.state.load && 
                <MassiveComponent
                  onChange={this.handlerChange}
                  values={this.state.form}
                  onSubmit={this.handlerSubmit}
                />
              }
              {
                this.state.load &&
                <div className='line line-100'>
                  <div style={{ display: 'margin: 5px' }}>Cargando Archivo</div>
                  <div style={{ display: 'inline-block', padding: '10px 0' }}>
                    <LoaderDots />
                  </div>
                </div>
              }
              <MassivePrompt propmt={this.state.propmt} load={this.state.load} />
              {/* <input type='button' value='tal' onClick={this.onEnd} /> */}
            </div>
          </div>
        </div>
      </Landing>
    );
  }
}


function mapStateToProprs(state) {
  return {
      session: state.session
  }
}

function mapDispathToProps(dispatch) {
  return {
      sessionActions: bindActionCreators(sessionActs, dispatch),
  }
}

export default connect(mapStateToProprs, mapDispathToProps)(MassiveLoadContainer)
